import React, { memo } from 'react';
import '@xyflow/react/dist/style.css';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { LdgNodeData } from './useLdgGraphData';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
export const LdgGraphNode = memo(({
  data,
  selected
}: NodeProps<LdgNodeData>) => {
  const {
    colorSet
  } = data;
  return <div className={`
        relative min-w-[240px] rounded-xl border-2 shadow-sm transition-all duration-200 bg-white
        ${selected ? `border-[${colorSet.ring}] ring-4 ring-[${colorSet.ring}]/20 shadow-md scale-105 z-10` : 'border-slate-200 hover:border-slate-300'}
      `} style={{
    borderColor: selected ? colorSet.ring : undefined
  }} data-id="element-5873" data-mp="gy7b21oujgtg">
        {/* Target Handle (Incoming) */}
        <Handle type="target" position={Position.Left} className="w-3 h-3 border-2 border-white bg-slate-400" data-id="element-5874" data-mp="14mi1sc0tw040" />

        {/* Header */}
        <div className={`px-3 py-2 rounded-t-lg border-b border-slate-100 flex items-center justify-between ${colorSet.light}`} data-id="element-5875" data-mp="19jgxv041yh4u">
          <div className="flex items-center gap-2" data-id="element-5876" data-mp="10t7b4q05sa90">
            <div className={`w-2 h-2 rounded-full ${colorSet.bg}`} data-id="element-5877" data-mp="10vl6kzyr3oh3" />
            <span className={`text-xs font-bold uppercase tracking-wider ${colorSet.text}`} data-id="element-5878" data-mp="wsoiitqfz05r">
              {data.module}
            </span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-5879" data-mp="1ohzzo1egbftl">
            <span className="text-xs font-mono font-medium text-slate-500 bg-white px-1.5 py-0.5 rounded shadow-sm border border-slate-100" data-id="element-5880" data-mp="1okvx7ome02hi">
              T{data.tier}
            </span>
            <span className={`text-xs font-bold px-1.5 py-0.5 rounded ${colorSet.bg} text-white shadow-sm`} data-id="element-5881" data-mp="1fomx07ql4zub">
              {data.levelCode}
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="p-3" data-id="element-5882" data-mp="23fse0q89hy67">
          <div className="font-mono font-bold text-sm text-slate-800 mb-1 truncate" title={data.label} data-id="element-5883" data-mp="23fk0cw4beoty">
            {data.label}
          </div>
          <div className="text-xs text-slate-500 truncate" title={data.subSkill} data-id="element-5884" data-mp="2rbx4tjk97xpe">
            {data.skill} • {data.subSkill}
          </div>

          {/* Status Indicator */}
          <div className="mt-3 flex items-center justify-between" data-id="element-5885" data-mp="2hksqmm2ekgvm">
            <div className="flex items-center gap-1 text-xs" data-id="element-5886" data-mp="23mcicqow6ibd">
              <span className="text-slate-400" data-id="element-5887" data-mp="23o5rqdqw3gn2">Prereqs:</span>
              <span className="font-medium text-slate-700" data-id="element-5888" data-mp="28m78ut4r95vw">
                {data.prerequisites.length}
              </span>
            </div>
            {!data.hasContent && <div className="flex items-center gap-1 text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded text-[10px] font-medium border border-amber-100" data-id="element-5889" data-mp="1ymgd6o4gkku8">
                <AlertTriangle className="w-3 h-3" data-id="element-5890" data-mp="3p07ac8j913l9" />
                <span data-id="element-5891" data-mp="3t1alwiu9kdgo">No Content</span>
              </div>}
            {data.hasContent && <div className="flex items-center gap-1 text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded text-[10px] font-medium border border-emerald-100" data-id="element-5892" data-mp="1hep98ve9nb9z">
                <CheckCircle2 className="w-3 h-3" data-id="element-5893" data-mp="1r3gvqo0k53di" />
                <span data-id="element-5894" data-mp="1r48rbyu5n13s">Active</span>
              </div>}
          </div>
        </div>

        {/* Source Handle (Outgoing) */}
        <Handle type="source" position={Position.Right} className="w-3 h-3 border-2 border-white bg-slate-400" data-id="element-5895" data-mp="1maxjpvhiqgat" />
      </div>;
});
LdgGraphNode.displayName = 'LdgGraphNode';